// styles imports
import './Grid.scss';

// メインのコンポーネント定義
export default function Grid(props) {
  return (
    <div className={"grid " +  (props.className ? props.className : "")} style={{gridTemplateColumns : `repeat(${props.size} ,1fr)`}}>
      {props.children}
    </div>
  );
}
